<template>
  <div>
    <span class="tip">
      <i class="iconfont iconInfo-Solid"></i>
      {{ $t('system::rbac::auth_board_tip') }}
    </span>
    <el-tree
      v-loading="loading"
      class="tree"
      :data="boardList"
      show-checkbox
      default-expand-all
      node-key="boardID"
      ref="tree"
      highlight-current
      :props="defaultProps"
    ></el-tree>
    <div style="text-align:end;margin-top:10px">
      <el-button :loading="sumbitLoading" @click="sumbit" type="primary" size="small" style="width:90px">
        {{ $t('system::common::btn::save') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { getBoardAuthList, saveBoardAuthList } from '@/server/system'
import { getMenuList } from '@/server/dashboard'
export default {
  props: {
    roleId: {
      default: '',
      type: [Number, String]
    }
  },
  async mounted() {
    await this.getBoardList()
    this.getBoardAuthList()
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'folderName'
      },
      boardList: [],
      loading: false,
      sumbitLoading: false
    }
  },
  methods: {
    async getBoardList() {
      this.loading = true
      const res = await getMenuList({ type: 1, pageNum: 1, pageSize: 10000 })
      this.loading = false
      if (res.status !== 200) {
        return
      }
      const data = res.result
      if (data.code === this.$code) {
        this.boardList = data.data.items.map(el => {
          return { ...el, boardID: el.folderID }
        })
      }
    },
    async getBoardAuthList() {
      this.loading = true
      const data = await getBoardAuthList(this.roleId)
      this.loading = false
      if (data.data.code === this.$code) {
        this.$refs.tree.setCheckedKeys(data.data.data.boardIds, true)
      }
    },
    search() {
      this.getBoardAuthList()
    },
    async sumbit() {
      let list = this.$refs.tree.getCheckedKeys(true)
      this.sumbitLoading = true
      const data = await saveBoardAuthList({ roleId: this.roleId, boardIds: list })
      if (data.result.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
      } else {
        this.$message.error(this.$t('system::tip::save_error'))
      }
      this.sumbitLoading = false
    }
  }
}
</script>

<style scoped lang="scss">
.tree {
  height: 465px;
  overflow: auto;
}
.tip {
  display: flex;
  align-items: center;
  color: #999;
  font-size: 12px;
  margin-top: 16px;
  .iconInfo-Solid {
    color: #999;
    font-size: 14px;
    margin-right: 4px;
  }
  margin-bottom: 16px;
}
.content {
  overflow: auto;
  height: 372px;
}
</style>
